const NAME = "BOT_ASSISTANT";

export default NAME;
